export default __webpack_public_path__ + "static/media/search.211a388d.svg";